import { render, staticRenderFns } from "./maintenanceRecords.vue?vue&type=template&id=dd33d5fa&scoped=true&"
import script from "./maintenanceRecords.vue?vue&type=script&lang=js&"
export * from "./maintenanceRecords.vue?vue&type=script&lang=js&"
import style0 from "./maintenanceRecords.vue?vue&type=style&index=0&id=dd33d5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd33d5fa",
  null
  
)

export default component.exports